/* COVA shop the look: the dot of the open panel changes colour */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    CV.register('[data-cv-stl]', function (root) {
      root.querySelectorAll('[data-cv-stl-panel]').forEach(function (panel) {
        var dot = root.querySelector('[data-cv-open="' + panel.id + '"]');
        var spot = dot && dot.closest('.cv-stl__spot');
        if (!spot) return;
        panel.addEventListener('cv:open', function () { spot.classList.add('is-active'); });
        panel.addEventListener('cv:close', function () { spot.classList.remove('is-active'); });
      });
    });
  });
})();
